type ImgMap = {
  [key: string]: string;
};

export const programsBuyPointLink: ImgMap = {
  av: "https://www.lifemiles.com/miles/buy",
  ua: "https://buymiles.mileageplus.com/united/marchtransfer/index_en.html",
  af: "https://buymiles.mileageplus.com/united/marchtransfer/index_en.html",
  as: "https://storefront.points.com/mileage-plan/en-US/buy?irgwc=1&referralCode=",
  ac: "https://www.aircanada.com/ca/en/aco/home/aeroplan/your-aeroplan.html",
  b6: "https://trueblue.jetblue.com/buy-points/?irgwc=1&referralCode=",
  vs: "https://flywith.virginatlantic.com/gb/en/flying-club/earn-points/buy-points.html",
  f9: "https://buy.points.com/marketing/frontier/",
  aa: "https://www.aa.com/aadvantage-program/buy-gift-transfer/en_US/home/buy",
};

export const bankCardImg: ImgMap = {
  bilt: "https://img.awardtool-api.com/bilt_1x.png",
  chase: "https://img.awardtool-api.com/chase_1x.png",
  amex: "https://img.awardtool-api.com/amex_1x.png",
  "capital one": "https://img.awardtool-api.com/capital_one_1x.png",
  citi: "https://img.awardtool-api.com/citi_1x.png",
  marriott: "https://img.awardtool-api.com/marriott_1x.png",
  "wells fargo": "https://img.awardtool-api.com/wells_fargo_1x_v3.png",
};

export const bankCardSmallImg: ImgMap = {
  bilt: "https://img.awardtool-api.com/bank_img/bilt_small.png",
  chase: "https://img.awardtool-api.com/bank_img/chase_small.png",
  amex: "https://img.awardtool-api.com/bank_img/amex_small.png",
  "capital one": "https://img.awardtool-api.com/bank_img/capital_one_small.png",
  citi: "https://img.awardtool-api.com/bank_img/citi_small.png",
  marriott: "https://img.awardtool-api.com/bank_img/marriott_small.png",
  "wells fargo": "https://img.awardtool-api.com/bank_img/wells_fargo_small.png",
};

// https://img.awardtool-api.com/city_imgs/{city_name}.jpg
export const CITY_IMG = ['athens',
  'xiamen',
  'glasgow',
  'bangalore',
  'austin',
  'belo_horizonte',
  'jacksonville',
  'portland',
  'medina',
  'qingdao',
  'harbin',
  'lima',
  'brisbane',
  'istanbul',
  'dusseldorf',
  'hohhot',
  'port_louis',
  'mumbai',
  'kolkata',
  'paris',
  'dubai',
  'madrid',
  'new_orleans',
  'frankfurt_am_main',
  'chiang_mai',
  'guangzhou',
  'seoul',
  'yinchuan',
  'new_york',
  'tenerife_island',
  'santa_ana',
  'las_vegas',
  'fukuoka',
  'san_antonio',
  'miami',
  'fort_myers',
  'brasilia',
  'cape_town',
  'barcelona',
  'addis_ababa',
  'marrakech',
  'taiyuan',
  'guadalajara',
  'dallas',
  'ankara',
  'san_jose',
  'vienna',
  'atlanta',
  'washington',
  'perth',
  'fortaleza',
  'beijing',
  'copenhagen',
  'adelaide',
  'tunis',
  'nashville',
  'casablanca',
  'dublin',
  'bucharest',
  'vancouver',
  'fort_lauderdale',
  'bogota',
  'jakarta',
  'stockholm',
  'anchorage',
  'antalya',
  'shijiazhuang',
  'london',
  'sydney',
  'auckland',
  'kansas_city',
  'changsha',
  'guiyang',
  'detroit',
  'jinan',
  'lyon',
  'zurich',
  'stuttgart',
  'wenzhou',
  'ahmedabad',
  'tokyo',
  'belgrad',
  'lanzhou',
  'los_angeles',
  'bangkok',
  'xining',
  'surabaya',
  'tampa',
  'lagos',
  'salt_lake_city',
  'hong_kong',
  'west_palm_beach',
  'santiago',
  'johannesburg',
  'denpasar-bali_island',
  'moscow',
  'urumqi',
  'nice',
  'yangon',
  'shanghai',
  'edmonton',
  'dabolim',
  'chengdu',
  'nanjing',
  'malaga',
  'san_diego',
  'lihue',
  'doha',
  'chongqing',
  'kuala_lumpur',
  'milan',
  'fuzhou',
  'taipei',
  'lapu-lapu_city',
  'edinburgh',
  'chennai',
  'napoli',
  'abu_dhabi',
  'philadelphia',
  'havana',
  'reykjavik',
  'cleveland',
  'gothenburg',
  'campinas',
  'trabzon',
  'oakland',
  'jeddah',
  'monterrey',
  'prague',
  'birmingham',
  'munich',
  'helsinki',
  'tocumen',
  'charlotte',
  'sanya',
  'st_louis',
  'da_nang',
  'christchurch',
  'zhengzhou',
  'shenyang',
  'montreal',
  'taipei_city',
  'marseille',
  'manila',
  'ezeiza',
  'salvador',
  'rio_de_janeiro',
  'valencia',
  'porto',
  'tokoname',
  'algiers',
  'st._petersburg',
  'recife',
  'tijuana',
  'rome',
  'toronto',
  'tehran',
  'haikou',
  'hamburg',
  'mexico_city',
  'manchester',
  'venezia',
  'windsor_locks',
  'tel_aviv',
  'sao_paulo',
  'palma_de_mallorca',
  'new_delhi',
  'san_francisco',
  'columbus',
  'bologna',
  'xianyang',
  'sacramento',
  'tianjin',
  'budapest',
  'cochin',
  'phuket',
  'covington',
  'cancun',
  'nairobi',
  'phoenix',
  'wellington',
  'minneapolis',
  'medan-sumatra_island',
  'oslo',
  'newark',
  'warsaw',
  'cairo',
  'nanchang',
  'melbourne',
  'sofia',
  'kaohsiung_city',
  'orlando',
  'lisbon',
  'hangzhou',
  'houston',
  'osaka',
  'naha',
  'ho_chi_minh_city',
  'dallas-fort_worth',
  'newcastle',
  'baltimore',
  'boston',
  'shenzhen',
  'halifax',
  'amsterdam',
  'chicago',
  'porto_alegre',
  'busan',
  'geneva',
  'gold_coast',
  'penang',
  'calgary',
  'wuxi',
  'pittsburgh',
  'ningbo',
  'changchun',
  'seattle',
  'nanning',
  'dalian',
  'riyadh',
  'wuhan',
  'indianapolis',
  'denver',
  'singapore',
  'brussels',
  'kunming',
  'honolulu',
  'hanoi',
  'buenos_aires',
  'hyderabad',
  'yantai', 'chitose_:_tomakomai',
  "governor's_harbour",
  'camaguey',
  'silao',
  'liberia',
  'kuwait_city',
  'basseterre',
  'santa_clara',
  'saint_martin',
  'varadero',
  'milwaukee',
  'muscat',
  'nassau',
  'managua',
  "saint_george's",
  'dayton',
  'hamilton',
  'montego_bay',
  'phnom_penh',
  'lahore',
  'montevideo',
  'comayagua',
  'dar_es_salaam',
  'oranjestad',
  'larnarca',
  'queenstown',
  'vieux_fort',
  'albuquerque',
  'torreon',
  'quito',
  'punta_cana',
  'ontario',
  'charlottesville',
  'islamabad',
  'oklahoma_city',
  'canberra',
  'colombo',
  'greensboro',
  'syracuse',
  'st._george',
  'cozumel',
  'hannover',
  'eindhoven',
  'rotterdam',
  'cologne',
  'tucson',
  'luxembourg',
  'bremen',
  'mulhouse',
  'kraków',
  'madison',
  'amman',
  'providenciales_island',
  'willemstad',
  'belize_city',
  'cartagena',
  'puerto_plata',
  'trivandrum',
  'pensacola',
  'sarasota:bradenton',
  'buffalo',
  'malé',
  'christiansted',
  'fort-de-france',
  'san_juan',
  'rochester',
  'myrtle_beach',
  'the_valley',
  'mahe_island',
  'beirut',
  'mykonos_island',
  'wilmington',
  'charlotte_amalie',
  'kailua:kona',
  'kingston',
  'san_jose_del_cabo',
  'holguin',
  'manaus',
  'louisville',
  'sevilla',
  'dhaka',
  'port_of_spain',
  'bridgetown',
  'puerto_vallarta',
  'kahului',
  'charleston',
  'manama',
  'amritsar.',
  'raleigh:durham',
  'tulsa',
  'george_town',
  'kraków',
  'georgetown',
  'kingstown',
  'sarasota:bradenton',
  'malé',
  'accra',
  'kathmandu',
  'kona',
  'almaty',
  'guatemala_city',
  'fresno',
  'palm_springs',
  '_tomakomai',
  'tirana',
  'tucson',
  'shannon',
  'faro',
  'merignac',
  'boise',
  'male',
  'raleighdurham',
  'spokane',
  'jackson',
  'thessaloniki',
  'memphis',
  'karachi',
  'durham',
  'catania',
  'blagnac',
  'omaha',
  'asheville',
  'torino',
  'nadi',
  'grand_rapids',
  'ottawa',
  'bilbao',
  'firenze',
  'reno',
  'tbilisi',
  'tashkent',
  'des_moines',
  'ljubljana',
  'belfast',
  'key_west',
  'santorini_island',
  'papeete',
  'zagreb',
  'rionegro',
  'kiembi_samaki',
  'bergen',
  'huntsville',
  'richmond',
  'luqa',
  'yerevan',
  'el_paso',
  'norfolk',
  'mulhouse',
  'split',
  'palermo',
  'bradenton',
  'dubrovnik']